import { REACT_APP_MIXPANEL_SUPPLIER } from 'constants/envs'

import { Analytics } from 'lib/events/analytics'
import {
  Platforms,
  type EventsType,
  type PlatformsType,
  type ScopesType,
} from 'lib/events/types'

export type EventProperties = Record<string, unknown> | undefined

export type UseAnalyticsProps = {
  platform: PlatformsType
  scope: ScopesType
  group?: Record<string, string[]>
}

export type SendEventArgs = EventProperties & {
  eventName: EventsType
}

export const analyticsInstance = new Analytics(
  REACT_APP_MIXPANEL_SUPPLIER,
  Platforms.App,
  { debug: false }
)

export function useAnalytics({ scope, platform, group }: UseAnalyticsProps) {
  function track(props: SendEventArgs) {
    const { eventName, ...properties } = props

    analyticsInstance.track(
      `${scope}__${eventName}`,
      {
        platform,
        ...properties,
      },
      group
    )
  }

  function pageview(props: SendEventArgs) {
    const { eventName, ...rest } = props

    analyticsInstance.pageview(
      {
        scope,
        platform,
        eventName: `${scope}__${eventName}`,
        ...rest,
      },
      group
    )
  }

  function timeEvent(eventName: EventsType) {
    analyticsInstance.timeEvent(`${scope}__${eventName}`, group)
  }

  function setGroup(label: string, value: string, props?: Record<string, any>) {
    analyticsInstance.setGroup(label, value, props)
  }

  function removeGroup(label: string, value: string) {
    analyticsInstance.removeGroup(label, value)
  }

  function identifyGroup(
    groupKey: string,
    groupValue: string,
    props?: Record<string, any>
  ) {
    analyticsInstance.identifyGroup(groupKey, groupValue, props)
  }

  return {
    track,
    timeEvent,
    pageview,
    setGroup,
    removeGroup,
    identifyGroup,
  }
}
